module.exports = __webpack_public_path__ + "static/media/info.caec83a2.svg";